/**
 * Shared budget utilities for the org summary (IB-641).
 */

/**
 * Returns the id of the evolving (non-locked / Latest Estimate) budget for an
 * event, or null when no unlocked budget exists.
 *
 * Relies on the backend ordering the `budgets` relation with locked budgets
 * first (`is_locked desc, created_at desc`), so iterating to the end and
 * keeping the last non-locked entry yields the most-recently-created evolving
 * budget. If the order ever changes this function should sort defensively.
 *
 * @param {{ budgets?: Array<{ id: number, is_locked: boolean }> }} event
 * @returns {number|null}
 */
export function findEvolvingBudgetId(event) {
    let evolving = null;
    (event.budgets || []).forEach((b) => {
        if (!b.is_locked) {
            evolving = b.id;
        }
    });
    return evolving;
}
